import { type Clips } from '@air/api';

import { type PrivateAssetOpenLocation } from '~/hooks/usePrivateAssetOpenLocation';

type PrivateDownloadUrlOptions = NonNullable<Parameters<typeof Clips.getDownloadUrl>[0]['options']>;

export const getPrivateDownloadUrlOptions = ({
  altResolutionId,
  analyticsLocation,
}: {
  altResolutionId?: PrivateDownloadUrlOptions['altResId'];
  analyticsLocation: PrivateAssetOpenLocation | null;
}): PrivateDownloadUrlOptions => ({
  ...(altResolutionId ? { altResId: altResolutionId } : {}),
  ...(analyticsLocation ?? {}),
});
